﻿export enum ProductState {
    Raw = 1,
    Bulk = 2,
    Intermediate = 3,
    FinishedGood = 4,
    Working = 5
}

export enum ProductLine {
    Common = 1,
    Environmental = 2,
    ClinTox = 3,
    Other = 8000,
    Custom = 9000
}

export enum BatchSizeType {
    Small = 1,
    Large = 2,
}

export enum AnalysisScopeType {
    QnmrAssignment = 1,
    MassBalanceAssignment = 2,
    QualitativeTraceability = 3,
    QuantitativeTraceability = 4,
    Identity = 5,
    ShortTermStability = 6,
    Homogeneity = 7
}

export enum QuickSearchItemType {
    ProductPlanning = 0,
    BatchPlanning = 1,
    ProductionBenchSheet = 2,
    RawMaterial = 3,
    Calculator = 4,
    QcBenchSheet = 5
}

export enum ResponseType {
    Information = 0,
    Warning = 1
}

export enum ModalMessageType {
    Information = 0,
    Warning = 1,
    Error = 3,
    PromptOk = 10,
    PromptYesNo = 11,
    PromptYesNoCancel = 12,
    PromptMessage = 13
}

export enum MessageBoxReplyType {
    Ok = 0,
    Cancel = 1,
    Yes = 2,
    No = 3,
    SubmitMessage = 4
}

export enum RoleLevelType {
    Viewer = 0,
    Tech = 1,
    TeamLead = 2,
    Admin = 3
}

export enum EditMode {
    New,
    Edit
}

export enum EditType {
    Insert = 0,
    Update = 2,
    Delete = 3,
    None = 4,
    InsertDelete = 5
}

export enum TicketType {
    BugReport = 1,
    Enhancement = 2,
    Documentation = 3,
    Maintenance = 4,
    DataUpdate = 5
}

export enum TicketSeverity {
    Deferred = 1,
    Low = 2,
    Medium = 3,
    High = 4,
    Immediate = 5
}

export enum TicketStatus {
    Closed = 0,
    InProcess = 1,
    PilotReview = 2,
    Submitted = 3,
    ReadyForProduction = 4,
    UpdateError = 5,
    Reviewing = 6,
    Approved = 7,
    Postponed = 8
}

export enum LogLevel {
    Verbose = 0,
    Debug = 1,
    Information = 2,
    Warning = 3,
    Error = 4,
    Fatal = 5
}

export enum BenchSheetReferenceType {
    Na = 1,
    UspMono = 2,
    EpMono = 3,
    OtherMethod = 4,
    InHouse = 5
}

export enum FieldUpdateType {
    Data = 0,
    Image = 1,
    Svg = 2,
    Document = 3
}

export enum HazardPictogramTypes {
    Explosive = 1,
    Flammable = 2,
    Oxidizing = 3,
    CompressedGas = 4,
    Corrosive = 5,
    Toxic = 6,
    Harmful = 7,
    HealthHazard = 8,
    EnvironmentalHazard = 9
}

export enum ImageFormatType {
    Svg = 0,
    Png = 1,
    Jpeg = 2,
    Gif = 3,
    Tiff = 4
}

export enum FtirOutputFileFormatType {
    SPA = 1,
    CSV = 2
}

export enum FtirStandardType {
    Aurum = 1,
    AurumPrevious = 2,
    USP = 3,
    EP = 4
}

export enum DataType {
    Object = 0,
    String = 1,
    Integer = 2,
    Decimal = 3,
    Date = 4,
    DateTime = 5,
    DateTimeOffset = 6,
    Boolean = 7,
    Guid = 8
}

export enum PubChemDataType {
    String = 1,
    Integer = 5,
    Float = 7,
    Binary = 16
}

export enum NoteType {
    OtherInformation = 0,
    Method = 1,
    QA = 2,
    WasteDisposal = 3,
    ProductPlanning = 4,
    SpecialHandlingInstructions = 5,
    BatchAnalyticalMethodParameters = 6,
    BatchElution = 7,
    PreparationInstructions = 8,
    SamplePreparation = 9,
    BatchPlanning = 10,
    ProductionBenchSheet = 11,
    BenchSheet = 12,
    RawMaterialAnalysis = 20,
    ProductGeneralSpec = 30,
    QnmrCalculation = 100,
    TestSpecComment = 200,
    TestSpecUncertainty = 201,
    TestSpecPassingSpec = 202,
    TestSpecMaterialDescription = 203,
    TestSpecExpirationDating = 204,
    Solvent = 250,
    CalibrationSummary = 260,
    Appearance = 300,
    AppearanceExtraneousMatter = 310,
    TaskTypeDescription = 500,
    TaskDescription = 550,
    ProductEhsHandlingInformation = 600

}

export enum ImageType {
    General = 0,
    WeightTicket = 1,
    MolecularImage = 2,
    SvgMolecularImage = 3,
    ImpurityChromatogram = 100,
    AssayChromatogram = 101,
    AssayChromatogramMs = 102,
    AssayChromatogramUsp = 103,
    AssayChromatogramEp = 104,
    AssayChromatogramBp = 105,
    Chromatogram = 106,
    Spectral = 107,
    Micro = 108,
    MassSpec = 109,
    Impurity = 110,
    Structure = 111,
    SpectralCoefficients = 112,
    ProtonQnmrCoa = 200,
    ProtonNmrCoa = 201,
    ProtonQnmrOther = 202,
    TestSpecMolecularImage = 300,
    COA = 500
}

export enum VmiGroups {
    AnalyticalBalance = 1,
    BsAmpuleSealer = 2,
    BiologicalCabinet = 3,
    Clock = 4,
    CoolerStand = 5,
    CoulometricTitrator = 6,
    Cozzoli = 7,
    Crimper = 8,
    Desiccator = 9,
    DryingOven = 10,
    Enclosure = 11,
    EnvironmentalChamber = 12,
    EppendorfRepeaterPipette = 13,
    Evaporator = 14,
    Ftir = 15,
    FumeHood = 16,
    Gc = 17,
    GloveBox = 18,
    Hplc = 19,
    MicroashFurnace = 20,
    Nmr = 21,
    NonanalyticalBalance = 22,
    PhMeter = 23,
    Printer = 24,
    Sonicator = 25,
    StirHotPlate = 26,
    Thermometer = 27,
    ThermometerHygrometer = 28,
    Toc = 29,
    VolumetricTitrator = 30,
    WaterBath = 31,
    CertifiedWeights = 32,
    UvLamp = 33,
    MeltingBoilingPoint = 34,
    VacuumDryingOven = 35,
    Dispensette = 36,
    Densitometer = 37,
    ConductivityMeterEquipment = 38,
    TypeIWater = 39,
    Polarimeter = 40,
    GlasswareWasher = 41,
    Anemometer = 42,
    Refractometer = 43,
    Freezer = 44
}

export enum AssetType {
    Balance = 1,
    Instrument = 2,
    Oven = 3,
    Weight = 4,
    DIWater = 5,
    pHMeter = 6,
    Dessicator = 7,
    Sonicator = 8,
    Miscellaneous = 9,
    PlateReader = 10,
    Incubator = 11
}

export enum DocumentType {
    General = 1,
    Text = 2,
    CSV = 3,
    Word = 50,
    Excel = 51,
    PowerPoint = 52,
    UspMono = 100,
    EpMono = 101,
    BpMono = 103,
    ChemSafe = 200,
    CofA = 201,
    SafetySheet = 202,
    ColumnCertificate = 203,
    GlasswareCertificate = 204,
    AnalyticalPlanMonograph = 300,
    SpectralMs = 400,
    SpectralUsp = 401,
    SpectralBp = 402,
    SpectralEp = 403,
    FtirAsIsSpectralCoefficient = 420,
    FtirRecrystalizedSpectralCoefficient = 421,
    FtirDryingSpectralCoefficient = 422,
    FtirSaltSpectralCoefficient = 423,
    KarlFischerWeightData = 500,
    GcRsData = 501,
    RoiWeightData = 502,
    RoeWeightData = 503,
    LodWeightData = 504,
    ShelfLifeSupport = 600,
    StandardsDocument = 700,
    AbsoluteStandardsCoa = 701,
    AccuStandardCoa = 702,
    AlfaAesarCoa = 703,
    AmbeedCoa = 704,
    AmcoClearCoa = 705,
    AquastarCoa = 706,
    BiosynthCarbosynthCoa = 707,
    BldPharmCoa = 708,
    BocSciencesCoa = 709,
    BritishPharmacopoeiaCoa = 710,
    CambridgeIsotopeLaboratoriesCoa = 711,
    EmdMilliporeCorpCoa = 712,
    EuropeanPharmacopoeiaCoa = 713,
    HachCoa = 714,
    HoneywellFlukaCoa = 715,
    InorganicVenturesCoa = 716,
    LgcMikromolCoa = 717,
    MerckCoa = 718,
    MilliporeSigmaCoa = 719,
    MolcanCoa = 720,
    NistCoa = 721,
    PhytolabCoa = 722,
    RestekCoa = 723,
    RocheCoa = 724,
    SigmaAldrichCoa = 725,
    SikeCoa = 726,
    SupelcoCoa = 727,
    TheNatureNetworkCoa = 728,
    TokyoChemicalIndustryCoa = 729,
    TorontoResearchChemicalsCoa = 730,
    UnitedStatesPharmacopiaCoa = 731,
    //standards document types reserved through 999

    CalibrationSummary = 1200,
    Asset = 1210,
    ProductSds = 1300,
    ProductPlanning = 1310,
    BatchPlanning = 1320,
    ProductionBenchSheet = 1330,
    Method = 1400,
    TiterCertificate = 1500


}

export enum AssetStatus {
    Inactive = 0,
    Active = 1,
    ActiveCalibrateBeforeUse = 2,
    ActiveLimitedUse = 3,
    ActiveMissing = 4,
    ActiveOot = 5,
    ActiveOutForCalibration = 6,
    ActiveOutOfService = 7,
    ActivePendingCompletion = 8,
    ActivePendingOot = 9
}

export enum BenchSheetTechnologyType {
    Na = 0,
    BoilingPoint = 200,
    Conductivity = 300,
    Density = 400,
    FourierTransformInfraredSpectroscopy = 500,
    GasChromatography = 600,
    GasChromatographyResidualSolvents = 700,
    HighPerformanceLiquidChromatography = 800,
    IonChromatography = 900,
    InductivelyCoupledPlasmaSpectroscopy = 1000,
    KarlFischerCoulometric = 1100,
    KarlFischerTitrimetric = 1200,
    LossOnDrying = 1300,
    MeltingPoint = 1400,
    MeltingRange = 1500,
    OpticalRotation = 1600,
    Ph = 1700,
    MassSpectrometry = 1800,
    RefractiveIndex = 1900,
    ResidueOnEvaporation = 2000,
    ResidueOnIgnition = 2100,
    SpecificGravity = 2200,
    Titration = 2300,
    TotalOrganicCarbon = 2400,
    Turbidity = 2500,
    UvVisSpectroscopy = 2600,
    NuclearMagneticResonance = 2700,
    Gravimetric = 2800,
    QNuclearMagneticResonance = 2900

}

export enum MethodProductTypes {
    RawMaterial = 1,
    FinishedGood = 2,
    PHR = 3
}

export enum NmrTypes {
    Quantitative = 0,
    Hydrogen = 1
}

export enum AnalyticalPlanAnalysisType {
    Quantitative = 1,
    Qualitative = 2
}

export enum BenchSheetPhase {
    MethodDevelopment = 1,
    Investigation = 2,
    ApprovedMethod = 3
}

export enum PrimarySampleType {
    MobilePhase = 1,
    Diluent = 2,
    Samples = 3
}

export enum SamplePreparationMeasurementType {
    Sample = 1,
    Concentration = 2,
    FinalDilution = 3,
    Ph = 4
}

export enum WeightMeasurementType {
    Gravimetric = 1,
    Volumetric = 2
}

export enum GravimetricCalculationType {
    WW = 1,
    WW_BD = 2,
    WV = 4,
    Neat = 10
}

export enum CoaCertifiedValueUncertaintyType {
    None = 0,
    Analytical = 1,
    Gravimetric = 2
}

export enum BatchType {
    NewBatch = 1,
    Rebatch = 2,
    Alias = 3,
    Requalification = 4,
    Retest = 5
}

export enum MimeType {
    AtomXml = 1,
    AtomcatXml = 2,
    Bmp = 3,
    Css = 4,
    Csv = 5,
    Gif = 6,
    Html = 7,
    Javascript = 8,
    Jpeg = 9,
    Json = 10,
    Mp4 = 11,
    Mpeg = 12,
    Ogg = 13,
    Pdf = 14,
    Plain = 15,
    Png = 16,
    Rtf = 17,
    SmilXml = 18,
    SvgXml = 19,
    Tiff = 20,
    Xml = 21,
    Zip = 22,
    BinaryFile = 23,
    MicrosoftWord = 1000,
    MicrosoftWordX = 1001,
    MicrosoftExcel = 1002,
    MicrosoftExcelX = 1003,
    MicrosoftPowerPoint = 1004,
    MicrosoftPowerPointX = 1005,
    MicrosoftVisioDrawing = 1006,
    MicrosoftVisioDrawingX = 1007,
    Other = 9999
}

export enum Severity {
    NonSevere = 0,
    Information = 1,
    Warning = 2,
    Error = 3,
    Fatal = 4,
    Ἁρμαγεδών = 100
}

export enum ResultCodes {
    None = 0,
    MissingData = 1,
    IncidentalException = 2,
    UnexpectedResult = 3,
    Cancel = 4,
    Expiration = 100,
    SqlInjection = 200
}

export enum PassFail {
    Pass = 1,
    Fail = 2
}

export enum FormComponentType {
    TextBox = 1,
    RichTextBox = 2,
    NumberBox = 3,
    DateBox = 4,
    CheckBox = 5,
    RadioButton = 6,
    SelectBox = 7,
    ComboBox = 8,
    DataGrid = 9,
    ListBox = 10
}

export enum GlasswareType {
    Pipette = 1,
    Volumetrics = 2,
    Burette = 3
}

export enum BenchSheetModuleType {
    BenchSheetHeader = 1,
    Specification = 3,
    SystemSuitability = 4,
    HandlingAndStorageInstructions = 5,
    Standards = 6,
    Instrument = 7,
    MethodInformation = 8,
    ColumnLogbook = 9,
    CalibrationLogbook = 10,
    MobilePhasePreparation = 11,
    Gradient = 12,
    OvenRamp = 13,
    DiluentPreparation = 14,
    StandardsSamplesPreparation = 15,
    Data = 16,
    Notes = 17,
    Qa = 18
}

export enum AuditQueryType {
    ProductByProductId = 10,
    BatchByBatchId = 20,
    ComponentsActualByBatchId = 30,
    ComponentsActualByComponentsActualId = 31,
    RawMaterialByRawMaterialId = 100,
    RawMaterialBatchByRawMaterialBatchId = 110,
    AssetByAssetId = 200
}

export enum HplcDetectorType {
    UV = 1,
    RID = 2

    /*
    VWD = 1,
    DAD = 2,
    ELSD = 3,
    RID = 4,
    MS = 5,
    QQQ = 6,
    QTOF = 7,
    UV = 8
    */
}

export enum KarlFischerType {
    Coulometric = 0,
    Titration = 1,
}

export enum KarlFischerHeader {
    None = 0,
    Test = 1,
    Blanks = 2,
    Samples = 3,
    Drift = 4,
    Titer = 5,
    WaterContent = 6,
    QC = 7
}

export enum BenchSheetSampleType {
    None = 0,
    Company = 1,
    E = 100,
    M = 200,
    L = 300,
    Blanks = 400,
    Titer = 401,
    QC = 500,
    Random = 600,
    PrimaryReferenceStandard = 1000,
    MeltingPointStandard = 1010
}

export enum TestingStandardsType {
    Ms = 0,
    Usp = 1,
    Ep = 2,
    Bp = 3
}

export enum Entities {
    Products = 100,
    Compositions = 110,
    Solvents = 111,
    PackagingMaterials = 112,
    CompStandards = 120,
    AnalyticalPlans = 130,
    MolecularData = 140,
    BatchPlanning = 150,
    BatchProductions = 151,
    ComponentsActual = 160,
    RawMaterials = 170,
    RawMaterialBatches = 180,
    Assets = 190,
    ChemicalInventoryItems = 200,
    BenchSheets = 1000,
    BenchSheetAnalysisTypes = 1010,
    BenchSheetBasisTypes = 1020,
    SamplePreparations = 1030,
    SamplePreparationMeasurements = 1040,
    Gradients = 1050,
    ICGradients = 1051,
    IonChromatographyIonData = 1052,
    AnalysisData = 1200,
    BenchSheetReadings = 1210,
    PrimaryAnalysisBenchSheets = 1500, // ??
    GcBenchSheets = 1510,
    HplcBenchSheets = 1520,
    IcBenchSheets = 1530,
    IcpBenchSheets = 1540,
    FtirBenchSheets = 1550,
    GcRsBenchSheets = 1560,
    KfcBenchSheets = 1570,
    KftBenchSheets = 1580,
    LodBenchSheets = 1590,
    RoeBenchSheets = 1600,
    RoiBenchSheets = 1610,
    NmrBenchSheets = 1620,
    MicroBenchSheets = 1630,
    BpBenchSheets = 1640,
    ConductivityBenchSheets = 1650,
    DensityBenchSheets = 1660,
    MpBenchSheets = 1670,
    MrBenchSheets = 1680,
    OrBenchSheets = 1690,
    PhBenchSheets = 1700,
    QtofBenchSheets = 1710,
    RiBenchSheets = 1720,
    SgBenchSheets = 1730,
    TitrationBenchSheets = 1740,
    TocBenchSheets = 1750,
    TurbidityBenchSheets = 1760,
    UvVisBenchSheets = 1770,
    GravimetricBenchSheets = 1780,
    GasChromatographyAssets = 2000,
    Coas = 3000,
    CoaTools = 3010
}

export enum BenchSheetEntities {
    Header = 0,
    PrimaryAnalysis = 10,
    SecondaryAnalysis = 20,
    AnalysisTypes = 30,
    BasisTypes = 40,
    SamplePreparations = 100,
    SamplePreparationMeasurements = 110,
    GcData = 500,
    HplcData = 510,
    IcData = 520
}

export enum Uoms {
    Milliliters = 1,
    Liters = 2,
    Milligrams = 3,
    Gram = 4,
    Kilograms = 5,
    Hours = 6,
    Units = 7,
    Micrograms = 8,
    Microliters = 9,
    MicroC = 10,
    Ea = 11,
    Each = 12,
    Ounces = 13,
    KT = 14,
    AMP = 15,
    Meters = 16,
    Millimeters = 17,
    Micrometers = 18,
    MillilitersPerMinute = 19,
    PPM = 20,
    PPB = 21,
    PPT = 22,
    MilligramsPerMilliliter = 23,
    MilligramsPerLiter = 24,
    MilligramsPerGram = 25,
    MicrogramsPerMilliliter = 26,
    MicrogramsPerLiter = 27,
    MicrogramsPerGram = 28,
    MicrogramsPerMilligrams = 29,
    GramsPerMilliliter = 30,
    GramsPerLiter = 31,
    N = 33,
    Percent = 34,
    MillilitersPerSecond = 35,
    Centimeters = 36,
    CPS = 37
}

//these have corresponding types in DocumentTypes (700+)
export enum ManufacturerTypes {
    UNKNOWN = 0,
    ABUS = 1,
    ACUS = 2,
    ALFS = 3,
    AMBS5 = 4,
    AMCS = 5,
    AQSS = 6,
    BSCS = 7,
    BLDS = 8,
    BOSS = 9,
    BP = 10,
    CILS = 11,
    EMDS = 12,
    EP = 13,
    HACS = 14,
    HFUS = 15,
    IOVS = 16,
    LGCS = 17,
    MRKS = 18,
    MSGS = 19,
    MLCS = 20,
    NIST = 21,
    PYTS = 22,
    RTKS = 23,
    ROCS = 24,
    SGAS = 25,
    SIKS = 26,
    SUPS = 27,
    TNNS = 28,
    TCIS = 29,
    TRCS = 30,
    USP = 31
}

export enum RecentTimePeriodType {
    Last5Minutes = 1,
    Last30Minutes = 2,
    LastHour = 3,
    Last12Hours = 4,
    Last24Hours = 5
}

export enum StandardUpdateState {
    NoChange = 1,
    NewStandard = 2,
    CurrentLotChange = 3,
    Discontinued = 4,
    Planned = 5
}

export enum BenchSheetAnalysisType {
    Quantitative = 1,
    Qualitative = 2,
    Assay = 3,
    Impurity = 4,
    ShortTermStability = 5,
    LongTermStability = 6,
    Homogeneity = 7,
    TimeOfUse = 8,
    Identification = 9,
    MethodDevelopment = 10
}

export enum IcpBenchSheetType {
    OES = 1,
    MS = 2
}

export enum FtirAnalysisType {
    AsIs = 1,
    Recrystalized = 2,
    Dried = 3,
    Salt = 4
}

export enum CalculatorTypes {
    MultiComponentMasterAssay = 100,
    Neat = 200,
    Qnmr = 300,
    HplcMassSpec = 400
}

export enum ReportType {
    BatchPlanning = 50,
    GcBenchSheet = 100
}

export enum TestSpecFormatTypes {
    SpiQnmr = 1,
    SppQnmr = 2,
    SpiMassBalance = 3,
    SppMassBalance = 4,
    Intermediate = 5,
    IntermediateQnmr = 6
}

export enum AssignPurityFactorTypes {
    MassBalance = 1,
    Qnmr = 2
}

export enum TestSpecTestPlanTypes {
    RawMaterial = 1,
    FinishedProduct = 2,
    FinishedProductStress = 3,
    FinishedProductRetest = 4,
    FinishedProductRequalification = 5,
    IntermediateProduct = 6
}

export enum StandardLookupSearchByTypes {
    SubstanceName = 1,
    CatalogNumber = 2,
    CasNumber = 5
}

export enum StandardContainerTypes {
    Vial = 1,
    Ampoule = 2
}

export enum HplcCalculationTypes {
    Identity = 1,
    Distribution = 2,
    OverlabeledDistribution = 3
}

export enum SpecificAssetQueryTypes {
    BalancesInventory = 1,
    ProductionEquipment = 2,
    PipettesInventory = 3,
    WeightsInventory = 4,
    UpcomingRevalidation = 5,
    OverdueItems = 6
}

export enum AppearanceFormTypes {
    Solid = 1,
    Liquid = 2
}

export enum PrecautionaryStatementTypes {
    Prevention = 1,
    Response = 2,
    Storage = 3,
    Disposal = 4,
    General = 5
}

export enum AnalyticalPlanMethodLocationTypes {
    InHouse = 1,
    OutOfHouse = 2
}

export enum OpenBabelConvertFormats {
    MdlMol = 1,
    Png = 2,
    ProteinDataBank = 3,
    PubChem = 4,
    PubChemJson = 5,
    Smiles = 6,
    StlFile = 7,
    Svg = 8
}

export enum TreeNodeTypes {
    LocationZone = 100,
    LocationBin = 110,
}

export enum BarCodeSymboloyTypes {
    Code128 = 8,
    Ean128 = 15,
    DataMatrix = 22,
    QrCode = 23,
    EpcQrCode = 34,
    MicroQrCode = 35,
    AztecCode = 36
}

export enum EventType {
    TicketUpdate = 100,
    TicketInsert = 101,
    TicketDetailsAdded = 102,
    TicketClosed = 110,
    NpiSubmit = 200,
    NpiApproval = 201,
    BatchPlanSubmit = 300,
    BatchPlanApproval = 301,
    TaskAssignment = 1000
}

export enum EventStatusType {
    InProcess = 10,
    Completed = 20,
    Errors = 30,
    Archived = 100
}

export enum EventMonitorLevel {
    Logging = 10,
    Notifications = 20
}

export enum MethodState {
    Development = 1,
    Review = 2,
    Approved = 3
}

export enum AzureRelayRequestType {
    BalanceStableWeight = 100,
    BalanceDate = 110,
    BalanceTime = 120,
    BalanceId = 130,
    BalanceEnvironment = 140,
    BalanceValueRelease = 150,
    BalanceWeighingMode = 160,

    BalanceImplementedMtSicsCommands = 200,
    BalanceSerialNumber = 210,
    BalanceInformation = 220,
    BalanceUnit = 230,
    BalanceSetUnit = 240,
    BalanceAdjustment = 250,

    BalanceUserProfile = 260,
    BalanceCurrentUserProfile = 270,
    BalanceFullWeightData = 300
}